import { configureStore } from '@reduxjs/toolkit';
import apiReducer from './slices/investorSlice';
import apiMediaReducer from './slices/mediaSlice'
import apiAwardReducer from './slices/awardsSlice'

// import productReducer from './slices/productSlice';

const store = configureStore({
  reducer: {
    user: apiReducer,
    media: apiMediaReducer,
    award:apiAwardReducer
    // product: productReducer,
  },
});

export default store;
